/* Exclusive Furniture: phone-only helpers. Desktop is untouched.
   1) "Read more" for long SEO text blocks and long review widgets. The content stays
      on the page (search engines still read it); phones just see a shorter preview.
*/
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');
  var TARGETS = [
    { sel: '.ef-seo-collapsible, .ef-home-seo-v3, .ef-locations-seo, .ef-lp-seo-2026, .ef-aireloom-seo-2026, .ef-se-seo-2026, .ef-sf-seo-2026, .ef-home-seo-minimal', max: 420, more: 'Read more', less: 'Show less' },
    { sel: '.jdgm-all-reviews-widget', max: 1100, more: 'Show more reviews', less: 'Show fewer reviews' }
  ];
  function collapse(el, t) {
    if (el.dataset.efCollapse) return;
    if (el.scrollHeight < t.max * 1.5) return;
    el.dataset.efCollapse = '1';
    el.classList.add('ef-collapse', 'is-collapsed');
    el.style.setProperty('--ef-collapse-h', t.max + 'px');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ef-collapse__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = t.more;
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? t.less : t.more;
      if (!open) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    el.insertAdjacentElement('afterend', btn);
  }
  function run() {
    if (!MQ.matches) return;
    TARGETS.forEach(function (t) {
      document.querySelectorAll(t.sel).forEach(function (el) { collapse(el, t); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  // review widgets load late
  var tries = 0, iv = setInterval(function () { run(); if (++tries > 10) clearInterval(iv); }, 1500);
})();

/* 2) Whole-card tapping (all screen sizes).
   Clarity showed shoppers tapping card titles, prices and item labels that went nowhere.
   A tap anywhere on these cards now opens the card's own link. Buttons, swatches and
   other controls inside the card keep working exactly as before. */
(function () {
  var CARDS = '.product-card, [id$="__custom_liquid_kXJJcN"] article.card, [id$="__custom_liquid_kXJJcN"] article.sleepCard';
  var CONTROLS = 'a, button, input, select, textarea, label, summary, [role="button"], [onclick], .swatch, .swatches, quick-add, product-form';
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest(CARDS);
    if (!card || e.defaultPrevented) return;
    if (e.target.closest(CONTROLS)) return;
    var sel = window.getSelection && String(window.getSelection());
    if (sel && sel.length) return;
    var link = card.querySelector('a[href]:not([href^="#"]):not([href^="javascript"])');
    if (!link) return;
    if (e.metaKey || e.ctrlKey) { window.open(link.href, '_blank'); } else { window.location.href = link.href; }
  });
})();

/* 3) Financing calculator (/pages/furniture-financing-calculator).
   Clarity: 49 rage clicks, shoppers tapping Purchase Total / Down Payment in the result
   cards expecting to change them. Results now update as you type, those rows jump back
   to the amount boxes, phones get the number keypad, and a Get Approved button follows
   the results. The financing math and disclosures are untouched. */
(function () {
  function init() {
    var calc = document.querySelector('.ef-wf-calculator');
    if (!calc || calc.dataset.efUx) return;
    calc.dataset.efUx = '1';
    var total = calc.querySelector('#totalInput');
    var down = calc.querySelector('#downInput');
    var btn = calc.querySelector('.calc-btn');
    [total, down].forEach(function (i) { if (i) { i.setAttribute('inputmode', 'decimal'); i.setAttribute('enterkeyhint', 'done'); } });
    var t;
    function recalc() {
      clearTimeout(t);
      t = setTimeout(function () { if (btn && total && parseFloat(total.value) > 0) btn.click(); }, 450);
    }
    if (total) total.addEventListener('input', recalc);
    if (down) down.addEventListener('input', recalc);
    [total, down].forEach(function (i) { if (i) i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (btn) btn.click(); i.blur(); } }); });
    var results = calc.querySelector('.results-section');
    if (results) {
      results.addEventListener('click', function (e) {
        var row = e.target.closest('.detail-row');
        if (!row) return;
        var label = (row.querySelector('.d-label') || {}).textContent || '';
        var target = /down/i.test(label) ? down : (/purchase|financed/i.test(label) ? total : null);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { target.focus(); if (target.select) target.select(); }, 350);
      });
      var cta = document.createElement('div');
      cta.className = 'ef-calc-cta';
      cta.innerHTML = '<p>Ready to finance it? See the payment options you may qualify for.</p>' +
        '<a class="ef-calc-cta__btn" href="/pages/financing">Get Approved</a>';
      results.insertAdjacentElement('afterend', cta);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
